import React from 'react'
import PdfFileAccountActivation from '../../images/MLex2.0_AccountActivationAndAccess.pdf'
import PdfFileAreasOfInterest from '../../images/MLex2.0_AreasOfInterest.pdf'
import PdfFileDefinitionsIndustry from '../../images/MLex2.0_DefinitionsIndustrySectorsLexisNexis.pdf'
import PdfFileCustomizingContentSetsAndAlertActivation from '../../images/MLex2.0_CustomizingContentSetsAndAlertActivation.pdf'
import PdfFileEditingAlerts from '../../images/MLex2.0_EditingAlerts_v202001.pdf'
import PdfFilePortfolioOverview from '../../images/MLex2.0_PortfoliosOverview.pdf'
import PdfFileSearchCommands from '../../images/Search-Commands_v17Jun21.pdf'
import PdfSavedSearchesAlerts from '../../images/MLex2.0_Saved_Searches_and_Alerts-v28Apr21.pdf'
import PdfTopicTags from '../../images/MLex2.0_Topic_Tags_v20210819.pdf'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export default function Help () {
  document.title = 'MLex | Help'
  return (

    <div className='grid-content-full content-help'>
      <h1 className='section-header'>Help</h1>
      <p>Get the most out of your MLex subscription by understanding more about the functionality that is available. See the below help resources in written (PDF) and video formats.</p>
      <p>If you require further assistance, please contact your account manager or Customer Services:</p>
      <p><a className='supportLink' href='mailto:customerservices@mlex.com'>customerservices@mlex.com</a></p>
      <ul className='supportPhone no-list-style'>
        <li>UK (Toll Free) +44 800 999 3237</li>
        <li>US (Toll Free) +1 800 356 6547</li>
        <li>Hong Kong +852 2965 1424</li>
      </ul>

      <table className='resources'>
        <thead>
          <tr className='separated-dotted'>
            <th>Resource</th>
            <th>Available formats</th>
          </tr>
        </thead>
        <tbody>
          <tr className='separated-dotted'>
            <td>Activating and accessing your account</td>
            <td className='resource-links'>
              <a href={PdfFileAccountActivation} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Activating and accessing your account' />
              <a href='https://youtu.be/kZ8QQcsFTrI' target='_blank' className='icon icon_youtube' title='YouTube MLex2.0 Activating and accessing your account' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Customizing content sets and selecting alerts</td>
            <td className='resource-links'>
              <a href={PdfFileCustomizingContentSetsAndAlertActivation} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Customizing content sets and alert activation' />
              <a href='https://youtu.be/odgiss7MASQ' target='_blank' className='icon icon_youtube' title='YouTube MLex2.0 Customizing content sets and alert activation' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Customized content sets - Reducing the number of Daily alerts received</td>
            <td className='resource-links'>            
              <a href='https://www.youtube.com/watch?v=IdwNwZYLggg' target='_blank' className='icon icon_youtube video_icon_only'  title='YouTube MLex2.0 Customized content sets - Reducing the number of Daily alerts received' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Editing alerts</td>
            <td className='resource-links'>
              <a href={PdfFileEditingAlerts} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Editing alerts' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Saved searches and alerts</td>
            <td className='resource-links'>
              <a href={PdfSavedSearchesAlerts} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Saved searches and alerts' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Working with Portfolios (formerly Case Files)</td>
            <td className='resource-links'>
              <a href={PdfFilePortfolioOverview} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Portfolios overview (formerly Case Files)' />
              <a href='https://youtu.be/9dEraDbl--0' target='_blank' className='icon icon_youtube' title='YouTube MLex2.0 Portfolios overview (formerly Case Files)' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Definitions: Areas of Interest</td>
            <td className='resource-links'>
              <a href={PdfFileAreasOfInterest} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Areas Of Interest' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Definitions: Industry Sectors</td>
            <td className='resource-links'>
              <a href={PdfFileDefinitionsIndustry} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Industry Sectors' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Search commands</td>
            <td className='resource-links'>
              <a href={PdfFileSearchCommands} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Search commands' />
            </td>
          </tr>
          <tr className='separated-dotted'>
            <td>Topic tags</td>
            <td className='resource-links'>
              <a href={PdfTopicTags} target='_blank' className='icon icon_pdf' title='PDF MLex2.0 Topic tags' />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  )
}
